// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__38zLv","icon":"SortAdornment_icon__2CY8O","up":"SortAdornment_up__1iQWB","down":"SortAdornment_down__3EFVr","active":"SortAdornment_active__qw2Qn"};